var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEdit = function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7485 6.43358C11.8964 6.58449 11.8964 6.82601 11.7485 6.97692L5.49392 13.2565C5.34387 13.4079 5.16425 13.5268 4.96624 13.6058L1.5984 14.9719C1.45423 15.03 1.28934 14.9964 1.17936 14.8865C1.01879 14.7841 0.956316 14.5801 1.03192 14.4053L2.36664 11.0365C2.44557 10.8385 2.56444 10.6588 2.71584 10.5087L8.97816 4.24466C9.05101 4.17118 9.15018 4.12986 9.25364 4.12986C9.35709 4.12986 9.45626 4.17118 9.52912 4.24466L11.7485 6.43358ZM14.6585 1.85392L14.1463 1.34162C13.9282 1.12321 13.6324 1.00036 13.3238 1.00009H12.734C12.42 0.996202 12.1178 1.11937 11.8959 1.34162L10.4914 2.76209C10.3435 2.913 10.3435 3.15453 10.4914 3.30544L12.6719 5.51764C12.7448 5.59112 12.8439 5.63245 12.9474 5.63245C13.0508 5.63245 13.15 5.59112 13.2229 5.51764L14.6585 4.10494C14.8807 3.88301 15.0038 3.58069 14.9999 3.26663V2.67671C14.9996 2.36802 14.8768 2.07207 14.6585 1.85392Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconEdit.7453cdeb.svg";
export { ForwardRef as ReactComponent };